import React from "react";
import config from '../../../config';
import { Spin } from 'antd';

const STATUS_MAP = {
    completed: {
        label: "Attended",
        color: "#16A34A",
        bg: "#DCFCE7",
        icon: "📞",
        showCallNow: false,
    },
    "no-answer": {
        label: "Unattended",
        color: "#6B7280",
        bg: "#E5E7EB",
        icon: "📞",
        showCallNow: true,
    },
    busy: {
        label: "Declined",
        color: "#EF4444",
        bg: "#FEE2E2",
        icon: "❌",
        showCallNow: true,
    },
    failed: {
        label: "Failed",
        color: "#EF4444",
        bg: "#FEE2E2",
        icon: "❌",
        showCallNow: true,
    },
};

const CallBackLogs = ({ log, onCallNow, callingId }) => {
    if (!log) return null;
    const status = STATUS_MAP[log.callStatus] || {};
    const duration = formatDuration(log.callDurationSeconds);
    const calledAgo = getTimeAgo(log.start_time);
    const isCalling = callingId === log.callbackRequestId;


    return (
        <div style={styles.card}>
            {/* Top row */}
            <div style={styles.row}>
                {/* Requested by */}
                            <div style={{ fontSize: '12px', color: '#666' }}>
                                Requested By:{' '}
                                <b>{log.requestedBy}</b>{' '}
                                <span
                                    style={{
                                        color: '#714FFF',
                                        cursor: 'pointer',
                                        fontWeight: 600,
                                    }}
                                    title="Request ID"
                                    onClick={() => {
                                        window.open(`${config.opsDashboardURL}revamp-offline-consults/${log.requestId}`, "_blank");
                                 
                                    }}
                                >
                                    {log.requestId}
                                </span>
                            </div>

                <span
                    style={{
                        ...styles.status,
                        color: status.color,
                        background: status.bg,
                    }}
                >
                    {status.icon} {status.label}
                </span>
            </div>

            {/* Meta */}
            <div style={styles.meta}>
                {duration} <span style={styles.dot}>•</span> Called {calledAgo}
            </div>

            {/* Call Now */}
            {status.showCallNow && (
                <button
                    onClick={() => !isCalling && onCallNow(log)}
                    disabled={isCalling}
                    style={{
                        color: isCalling ? '#AAA' : '#7C5CFF',
                        cursor: isCalling ? 'not-allowed' : 'pointer',
                        padding: "4px 10px",
                        borderRadius: "14px",
                        border: "1px solid #7C5CFF",
                        background: "#fff",
                        fontWeight: 500,
                    }}
                >
                    <span style={{ color: '#714FFF', fontSize:'14px' }}>📞 Call Now</span>
                </button>
            )}
        </div>
    );
};

/* ---------- helpers ---------- */

function formatDuration(seconds = 0) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, "0")}m ${String(s).padStart(2, "0")}s`;
}

function getTimeAgo(date) {
    const diff = Math.floor((Date.now() - new Date(date)) / 1000);
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)} mins ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hrs ago`;
    return `${Math.floor(diff / 86400)} days ago`;
}

/* ---------- styles ---------- */

const styles = {
    card: {
        padding: "8px 0",
        borderBottom: "1px dashed #E5E7EB",
    },

    row: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },

    label: {
        color: "#6B7280",
    },

    rid: {
        color: "#7C5CFF",
        cursor: "pointer",
        marginLeft: "4px",
    },

    status: {
        fontSize: "12px",
        padding: "4px 8px",
        borderRadius: "999px",
        fontWeight: 500,
        whiteSpace: "nowrap",
    },

    meta: {
        marginTop: "6px",
        fontSize: "14px",
        color: "#6B7280",
    },

    dot: {
        margin: "0 6px",
    },

    callBtn: {
        marginTop: "10px",
        padding: "6px 14px",
        borderRadius: "20px",
        border: "1px solid #7C5CFF",
        background: "#fff",
        color: "#7C5CFF",
        cursor: "pointer",
        fontWeight: 500,
    },
};

export default CallBackLogs;
